import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from "axios";
import LoadPanel from 'devextreme-react/load-panel';
import 'devextreme/dist/css/dx.light.css';
import {
    Form,
    GroupItem,
    SimpleItem,
    Label,
    ButtonItem,
    EmailRule,
    PatternRule,
} from 'devextreme-react/form';

import notify from 'devextreme/ui/notify';
import RadioGroup from 'devextreme-react/radio-group';  //  SHOULD NOT BE REMOVE
import { SelectBox } from 'devextreme-react/select-box';//  SHOULD NOT BE REMOVE
import { CheckBox } from 'devextreme-react/check-box';  //  SHOULD NOT BE REMOVE
import FileUploader from 'devextreme-react/file-uploader';
import { Popup } from 'devextreme-react/popup'; //  FOR POP-UP
import Button from 'devextreme-react/button';

import HtmlEditor from 'devextreme-react/html-editor';  //  SHOULD NOT BE REMOVE
import {
    RequiredRule,
    StringLengthRule,
    CustomRule
} from 'devextreme-react/validator';

import './infringement-alert.scss';

const regionEditorOptions = [
    { id: "NORAM", name: "North America" },
    { id: "LATAM", name: "Latin America" },
    { id: "APAC", name: "Asia Paciffic" },
    { id: "EMEA", name: "Europe, Middle East, and Africa" },
];

const priorityEditorOptions = [
    { id: "low", name: 'Low' },
    { id: "medium", name: 'Medium' },
    { id: "high", name: 'High' }
];

const signaturePattern = '^/s/ [a-zA-Z0-9-._? ]+$';

const InfringementTypeOptions = [
    { id: "Trademark/Brand Infringement", name: 'Trademark/Brand Infringement' },
    { id: "Image/Copyright Infringement", name: 'Image/Copyright Infringement' },
    { id: "Patent Infringement", name: 'Patent Infringement' },
    { id: "Copyright Counter Notice", name: 'Copyright Counter Notice' }
];

const YesNoOptions = [
    { id: 'yes', name: 'Yes' },
    { id: 'no', name: 'No' }
];

const dateBoxOptions = {
    placeholder: '',
    acceptCustomValue: false,
    openOnFieldClick: true,
    displayFormat: "MMM dd, yyyy",
    validationMessageMode: "always"
};

const relevantPlatformOptions = [
    { id: "Abritel", name: "Abritel" },
    { id: "BEX", name: "BEX" },
    { id: "Bookabach", name: "Bookabach" },
    { id: "CheapTickets.com", name: "CheapTickets.com" },
    { id: "eBookers", name: "eBookers" },
    { id: "Fewo-direkt", name: "Fewo-direkt" },
    { id: "Hcom", name: "Hcom" },
    { id: "Stayz.com", name: "Stayz.com" },
    { id: "Vrbo", name: "Vrbo" },
    { id: "Other", name: "Other" },
];

const fileExtensions = ['.pdf', '.jpg', '.jpeg', '.png'];
const validFilesType = ['application/pdf', 'image/jpeg', 'image/png'];
const totMaxFileSize = 25 * 1024 * 1024; // 25MB

const prefilledData = {
    expedia_internal_user: false,
    phone_number: '',
    phone: '',
}

const InfringementAlert = () => {
    const navigate = useNavigate();

    //  TO KEEP THE FORM RESET ON LOAD
    const [dummyData, setDummyData] = useState(prefilledData);
    useEffect(() => {
        // Reset form data when the component mounts
        setDummyData(prefilledData);
    }, []);

    const formRef = useRef(null);
   
    const [infringementTypeCaption, setInfringementTypeCaption] = useState('Trademark/Brand Infringement');
    const [isTrademarkInfringement, setIsTrademarkInfringement] = useState(false);
    const [isImageInfringement, setIsImageInfringement] = useState(false);
    const [isPatentInfringement, setIsPatentInfringement] = useState(false);
    const [isCopyrightCounterNotice, setIsCopyrightCounterNotice] = useState(false);
    const updateInfringementDependentVisibility = (e) => {
        setInfringementTypeCaption(e.value);
        setIsTrademarkInfringement(e.value === 'Trademark/Brand Infringement');
        setIsImageInfringement(e.value === 'Image/Copyright Infringement');
        setIsPatentInfringement(e.value === 'Patent Infringement');
        setIsCopyrightCounterNotice(e.value === 'Copyright Counter Notice');
    };

    const [isAboutLogdingVrbo, setIsAboutLogdingVrbo] = useState(false);
    const updateAboutLodgingVrboDependentVisibility = (e) => {
        setIsAboutLogdingVrbo(e.value === 'yes');
    }

    const [isRelevantPlatformOther, setIsRelevantPlatformOther] = useState(false);
    const updateRelevantPlatformDependentVisibility = (e) => {
        setIsRelevantPlatformOther(e.value === 'Other');
    }

    const [isAboutVrboListing, setIsAboutVrboListing] = useState(false);
    const updateVrboListingDependentVisibility = (e) => {
        setIsAboutVrboListing(e.value === 'yes');
    }

    const maxFileUploadAllowed = 5;

    const editorToolbar = {
        items: ['bold', 'italic', 'strike', 'underline']
    }

    const getEditorOptions = (dataField) => {
        let editorOption = {
            height: 300,
            toolbar: editorToolbar
        };

        editorOption = {
            ...editorOption,
            validationMessageMode: "always"
        };

        return editorOption;
    };

    //  TO HANDLE FILE UPLOAD
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [isUploadValid, setIsUploadValid] = useState(true);
    const handleFileChange = useCallback((e) => {
        let files = e.value;
        const validCharsFilename = /^[a-zA-Z0-9-._? ]+$/;
        const uploadedFiles = [];
        let validFileNames = true;

        if (e.value) {
            setSelectedFiles(e.value);
        }

        let validationMessage =
            files.reduce((acc, file) => acc + file.size, 0) > totMaxFileSize
                ? `Total file size is greater than 25MB`
                : "Ready to upload";

        validationMessage =
            files.length > maxFileUploadAllowed
                ? `Cannot upload more than ${maxFileUploadAllowed} files`
                : validationMessage;

        for (let index = 0; index < files.length; index++) {
            if (
                e.component._files[index].$statusMessage.text() !==
                "File type is not allowed"
            ) {
                e.component._files[index].$statusMessage.text(e.component._files[index].value.size > totMaxFileSize ? 'File is too large!' : validationMessage);

                ((files.length > maxFileUploadAllowed) || (files.reduce((acc, file) => acc + file.size, 0) > totMaxFileSize))
                    ? e.component._files[index].$file.addClass(
                        "dx-fileuploader-invalid"
                    )
                    : e.component._files[index].$file.removeClass(
                        "dx-fileuploader-invalid"
                    );
            }

            if (files.length >= maxFileUploadAllowed) {
                e.component.option(
                    "labelText",
                    `Cannot upload more than ${maxFileUploadAllowed} files`
                );
            }
            else {
                e.component.option("labelText", "or Drop files here");
            }

            if (e.component._files[index].uploadButton) {
                e.component._files[index].uploadButton.option(
                    "disabled",
                    files.length > maxFileUploadAllowed
                );
            }

            //  TO CHECK FOR INVALID CHARACTERS in FILENAME
            if (!validCharsFilename.test(e.component._files[index].value.name)) {
                e.component._files[index].$statusMessage.text(`File name contains invalid characters`);
                e.component._files[index].$file.addClass(
                    "dx-fileuploader-invalid"
                )
            }

            //  TO CHECK FOR DUPLICATE FILENAME
            if (uploadedFiles.includes(e.component._files[index].value.name)) {
                validFileNames = false;
                e.component._files[index].$statusMessage.text(`Duplicate filename is not allowed`);
                e.component._files[index].$file.addClass(
                    "dx-fileuploader-invalid"
                )
            }
            else {
                uploadedFiles.push(e.component._files[index].value.name);
            }
        }

        setIsUploadValid(
            files.length <= maxFileUploadAllowed
            && files.reduce((acc, file) => acc + file.size, 0) <= totMaxFileSize
            && files.every(file => validFilesType.includes(file.type))
            && files.every(file => validCharsFilename.test(file.name))
            && validFileNames
        );
    }, [setSelectedFiles]);

    const [captchaText, setCaptchaText] = useState('');
    const [captchaImage, setCaptchaImage] = useState('');
    const [userCaptcha, setUserCaptcha] = useState('');

    const fetchCaptcha = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/captcha`);
            setCaptchaText(response.data.captchaText);
            setCaptchaImage(response.data.captchaImage);
        } catch (error) {
            console.error('Error fetching CAPTCHA:', error);
        }
    };

    useEffect(() => {
        const getFetchCaptcha = async () => {
            await fetchCaptcha();
        };

        getFetchCaptcha();
    }, []);

    //  TO HANDLE THE ARROWUP & ARROWDOWN KEY EVENT
    const disableUpDownArrow = (e) => {
        e.component.registerKeyHandler('upArrow', (event) => {
            event.preventDefault();
        });
        e.component.registerKeyHandler('downArrow', (event) => {
            event.preventDefault();
        });
    };

    const handleCaptchaEntry = (e) => {
        setUserCaptcha(e.value);
    }

    //  FOR "EVIDENCE PROVIDED" CHECKBOXES AND THEIR VSLIDATION - BOL
    const [isOpt1, setIsOpt1] = useState(false);
    const [isOpt2, setIsOpt2] = useState(false);
    const [isOpt3, setIsOpt3] = useState(false);
    const [isOpt4, setIsOpt4] = useState(false);
    const [isOpt5, setIsOpt5] = useState(false);
    const [isOpt6, setIsOpt6] = useState(false);
    const [isOpt7, setIsOpt7] = useState(false);
    const [isOpt8, setIsOpt8] = useState(false);

    const onFieldDataChanged = useCallback(
        (e) => {
            if (e.dataField === "advertisement") {
                setIsOpt1(e.value);
            } else if (e.dataField === "other") {
                setIsOpt2(e.value);
            } else if (e.dataField === "photos") {
                setIsOpt3(e.value);
            } else if (e.dataField === "product_manual") {
                setIsOpt4(e.value);
            } else if (e.dataField === "software") {
                setIsOpt5(e.value);
            } else if (e.dataField === "video") {
                setIsOpt6(e.value);
            } else if (e.dataField === "url_violation") {
                setIsOpt7(e.value);
            } else if (e.dataField === "website_violation") {
                setIsOpt8(e.value);
            }
        },
        []
    );

    const validationCallback = useCallback(
        (e) => {
            return isOpt1 || isOpt2 || isOpt3 || isOpt4 || isOpt5 || isOpt6 || isOpt7 || isOpt8;
        },
        [isOpt1, isOpt2, isOpt3, isOpt4, isOpt5, isOpt6, isOpt7, isOpt8]
    );
    //  FOR "EVIDENCE PROVIDED" CHECKBOXES AND THEIR VSLIDATION - EOL

    const [isSubmitting, setIsSubmitting] = useState(false);    //  TO BLOCK UI WHILE FORM IS SUBMITTING
    const [successMessage, setSuccessMessage] = useState('');   //  FOR POP-UP

    //  TO HANDLE FORM SUBMISSION
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (userCaptcha !== captchaText) {
            notify(
                {
                    message: 'Incorrect CAPTCHA. Please try again.',
                    position: {
                        my: 'center top',
                        at: 'center top',
                    },
                },
                'error',
                3000,
            );
            fetchCaptcha();
            return;
        }
        else if (!isUploadValid) {
            return;
        }

        let formData = new FormData(e.target);

        setIsSubmitting(true);
        setSubmitButtonOptions({ ...submitButtonOptions, disabled: true });

        for (let i = 0; i < selectedFiles.length; i++) {
            formData.append('files', selectedFiles[i]);
        }

        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/send_data`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });

            if (response.data.status === "success") {
                formRef.current.instance().reset();

                setSelectedFiles([]);
                // Reset form data when the component mounts
                document.getElementsByTagName("form")[0].reset();
                setDummyData(prefilledData);
                setIsSubmitting(false);

                // FOR POP-UP
                setSuccessMessage(response.data.message);
                showPopup();
            }
            else {
                notify(
                    {
                        message: response.data.message,
                        position: {
                            my: 'center top',
                            at: 'center top',
                        },
                    },
                    response.data.status,
                    3000,
                );

                setIsSubmitting(false);
                setSubmitButtonOptions({ ...submitButtonOptions, disabled: false });
            }
        } catch (error) {
            console.error('Error uploading files:', error);

            notify(
                {
                    message: `Error uploading files: ${error}`,
                    position: {
                        my: 'center top',
                        at: 'center top',
                    },
                },
                "error",
                3000,
            );

            setIsSubmitting(false);
            setSubmitButtonOptions({ ...submitButtonOptions, disabled: false });
        }

        fetchCaptcha();
    };
    // NEW APPROACH BOL
    const [submitButtonOptions, setSubmitButtonOptions] = useState({
        text: 'Submit',
        type: 'success',
        useSubmitBehavior: true,
        stylingMode: 'contained',
        width: 120,
        height: 40,
        icon: 'check',
        hint: 'Submit the form',
        disabled: false,
    });

    const [resetButtonOptions, setResetButtonOptions] = useState({
        disabled: true,
        text: 'Reset',
        type: 'default',
        onClick: () => {
            //  TO RESET THE FORM FIELDS
            formRef.current.instance().reset();

            //  TO CLEAR THE FILES SELECTION
            setSelectedFiles([]);
        },
        stylingMode: 'contained',
        width: 120,
        height: 40,
        icon: 'refresh',
        hint: 'Reset the form',
    });

    const onFormOptionChanged = useCallback(
        (e) => {
            if (e.name === 'isDirty') {
                setResetButtonOptions({ ...resetButtonOptions, disabled: !e.value });
            }
        },
        [resetButtonOptions, setResetButtonOptions],
    );
    // NEW APPROACH EOL

    //  TO VALIDATE TEXTBOX ENTRY
    const textValidationPattern = "^[a-zA-Z0-9-._ ]+$";
    const textValidationPatternMessage = "Only alphanumeric characters, '.', '-', '_' and space are allowed.";

    // FOR POP-UP
    const [popupVisible, setPopupVisible] = useState(false);

    const showPopup = () => {
        setPopupVisible(true);
    };

    const hidePopup = () => {
        setPopupVisible(false);

        window.location.reload(true);   // `true` reloads from server, `false` reloads from cache
    };

    return (
        <React.Fragment>
            <h2 className={'content-block'}>Infringement Alert</h2>
            <div className={'content-block'}>
                <div className={'dx-card responsive-paddings'}>
                    <form
                        onSubmit={handleSubmit}
                    >
                        <input type='hidden' name="request_number" value={Date.now()} />
                        <input type='hidden' name="request_type" value="Infringement Alert" />
                        <input type='hidden' name="expedia_internal_user" value="false" />

                        <Form
                            ref={formRef}
                            formData={dummyData}
                            showValidationSummary={false}
                            validationGroup="customerData"
                            labelLocation='top'
                            onFieldDataChanged={onFieldDataChanged}
                            onOptionChanged={onFormOptionChanged}
                        >
                            <GroupItem>
                                <GroupItem caption="Basic Request Information">
                                    <SimpleItem>
                                        <span>
                                            Please use this request type for any questions related to the Infringement Report of Expedia Group.
                                            <br />
                                            Please fill out the fields below. The field required, indicated by <span className="dx-field-item-required-mark">*</span> must be completed before submitting the form.
                                        </span>
                                    </SimpleItem>

                                    <GroupItem colCount={2}>
                                        {/* REQUEST SUBJECT */}
                                        <SimpleItem
                                            dataField="request_name"
                                            editorOptions={{ validationMessageMode: 'always' }}
                                        >
                                            <Label text="Request Subject" />

                                            <RequiredRule message="Request Subject is required" />
                                            <PatternRule
                                                message={textValidationPatternMessage}
                                                pattern={textValidationPattern}
                                            />
                                            <StringLengthRule
                                                min={5}
                                                max={80}
                                                message="Request Subject must have at least 5 characters and max of 80 characters long"
                                            />
                                        </SimpleItem>

                                        {/* SUBMITTER NAME */}
                                        <SimpleItem dataField="submitter_name" editorOptions={{ validationMessageMode: 'always' }}>
                                            <Label text="Submitter Name" />

                                            <RequiredRule message="Submitter Name is required" />
                                            <PatternRule
                                                message={textValidationPatternMessage}
                                                pattern={textValidationPattern}
                                            />
                                            <StringLengthRule
                                                max={200}
                                                message="Submitter Name must not exceed 200 characters"
                                            />
                                        </SimpleItem>

                                        {/* SUBMITTER EMAIL */}
                                        <SimpleItem dataField="submitter_email" editorOptions={{ validationMessageMode: 'always' }}>
                                            <Label text="Submitter Email" />

                                            <RequiredRule message="Submitter Email is required" />
                                            <EmailRule />
                                        </SimpleItem>

                                        {/* COMPANY NAME */}
                                        <SimpleItem dataField="company_name" editorOptions={{ validationMessageMode: 'always' }}>
                                            <Label text="Company Name" />

                                            <PatternRule
                                                message={textValidationPatternMessage}
                                                pattern={textValidationPattern}
                                            />
                                            <StringLengthRule
                                                max={200}
                                                message="Company Name must not exceed 200 characters"
                                            />
                                        </SimpleItem>

                                        {/* COUNTRY/REGION (WEB) */}
                                        <SimpleItem dataField="country_region" editorOptions={{ validationMessageMode: 'always' }}>
                                            <Label text='Country/Region' />

                                            <PatternRule
                                                message={textValidationPatternMessage}
                                                pattern={textValidationPattern}
                                            />
                                            <StringLengthRule
                                                max={200}
                                                message="Country/Region must not exceed 200 characters"
                                            />
                                        </SimpleItem>
                                    </GroupItem>

                                    {/* INFRINGEMENT TYPE */}
                                    <SimpleItem
                                        dataField="infringment_type"
                                        editorType="dxRadioGroup"
                                        editorOptions={{
                                            dataSource: InfringementTypeOptions,
                                            valueExpr: 'id',
                                            displayExpr: 'name',
                                            onValueChanged: updateInfringementDependentVisibility,
                                            layout: "horizontal",
                                            validationMessageMode: "always"
                                        }}
                                    >
                                        <Label text="Choose Infringement type" />
                                        <RequiredRule message="Infringement type is required" />
                                    </SimpleItem>

                                    {(isPatentInfringement || isCopyrightCounterNotice || isImageInfringement || isTrademarkInfringement) && (
                                        <GroupItem caption={infringementTypeCaption} colCount={2}>
                                            {/* IS THIS ABOUT LODGING? */}
                                            {(isTrademarkInfringement || isImageInfringement) && (
                                                <SimpleItem
                                                    dataField="lodgin_vrbo"
                                                    editorType="dxRadioGroup"
                                                    editorOptions={{
                                                        dataSource: YesNoOptions,
                                                        valueExpr: 'id',
                                                        displayExpr: 'name',
                                                        onValueChanged: updateAboutLodgingVrboDependentVisibility,
                                                        layout: "horizontal",
                                                        validationMessageMode: "always"
                                                    }}
                                                >
                                                    <Label text="Is this about lodging?" />
                                                    <RequiredRule message="This field is required" />
                                                </SimpleItem>
                                            )}

                                            {/* Relevant Platform */}
                                            {((isTrademarkInfringement && isAboutLogdingVrbo) || (isImageInfringement && isAboutLogdingVrbo)) && (
                                                <SimpleItem
                                                    dataField="relevant_platform"
                                                    editorType="dxSelectBox"
                                                    editorOptions={{
                                                        dataSource: relevantPlatformOptions,
                                                        onValueChanged: updateRelevantPlatformDependentVisibility,
                                                        valueExpr: "id",
                                                        displayExpr: "name",
                                                    }}
                                                >
                                                    <Label text="Relevant Platform" />
                                                </SimpleItem>
                                            )}

                                            {/* If Other */}
                                            {((isTrademarkInfringement && isAboutLogdingVrbo) || (isImageInfringement && isAboutLogdingVrbo)) && isRelevantPlatformOther && (
                                                <SimpleItem dataField="relevant_platform_other" editorOptions={{ validationMessageMode: 'always' }}>
                                                    <Label text="If Other" />
                                                    <RequiredRule message="If Other is required" />
                                                    <StringLengthRule
                                                        max={200}
                                                        message="If Other must not exceed 200 characters"
                                                    />
                                                </SimpleItem>
                                            )}

                                            {/* PROPERTY LISTING NUMBER */}
                                            {((isTrademarkInfringement && isAboutLogdingVrbo) || (isImageInfringement && isAboutLogdingVrbo)) && (
                                                <SimpleItem dataField="property_listing_number" editorOptions={{ validationMessageMode: 'always' }}>
                                                    <Label text="Property Listing Number" />

                                                    <PatternRule
                                                        message={textValidationPatternMessage}
                                                        pattern={textValidationPattern}
                                                    />
                                                    <StringLengthRule
                                                        max={200}
                                                        message="Property Listing Number must not exceed 200 characters"
                                                    />
                                                </SimpleItem>
                                            )}

                                            {/* SELECT REGION */}
                                            {((isTrademarkInfringement && isAboutLogdingVrbo) || (isImageInfringement && isAboutLogdingVrbo)) && (
                                                <SimpleItem
                                                    dataField="select_region"
                                                    editorType="dxSelectBox"
                                                    editorOptions={{
                                                        dataSource: regionEditorOptions,
                                                        valueExpr: "id",
                                                        // displayExpr: "name",
                                                        displayExpr: "id",
                                                        searchEnabled: true,
                                                        searchMode: 'contains', // [contains | startswith]
                                                        validationMessageMode: "always"
                                                    }}
                                                    helpText='NORAM = North America, LATAM = Latin America, APAC = Asia Pacific, EMEA = Europe, Middle East, and Africa'
                                                >

                                                    <Label text="Select Region" />
                                                    <RequiredRule message="This field is required" />
                                                </SimpleItem>
                                            )}

                                            {/* SUBMITTING DSA TAKEDOWN REQUEST */}
                                            {isImageInfringement && (
                                                <SimpleItem
                                                    dataField="submitting_dsa_takedown_request"
                                                    editorType="dxRadioGroup"
                                                    editorOptions={{
                                                        dataSource: YesNoOptions,
                                                        valueExpr: 'name',
                                                        displayExpr: 'name',
                                                        layout: "horizontal",
                                                        validationMessageMode: "always"
                                                    }}
                                                >
                                                    <Label text="Are you submitting a DMCA takedown request" />
                                                    <RequiredRule message="This field is required" />
                                                </SimpleItem>
                                            )}

                                            {/* CONTACT PHONE NUMBER */}
                                            {(isTrademarkInfringement || isImageInfringement || isCopyrightCounterNotice) && (
                                                <SimpleItem
                                                    dataField="phone_number"
                                                    editorType="dxNumberBox"
                                                    editorOptions={{
                                                        validationMessageMode: 'always',
                                                        onInitialized: disableUpDownArrow,
                                                        format: '#', // This ensures only integers are accepted
                                                    }}
                                                >
                                                    <Label text="Contact Phone Number" />

                                                    <CustomRule
                                                        validationCallback={(e) => {
                                                            const value = e.value.toString();
                                                            return (value.length === 0) || (value.length >= 7 && value.length <= 12);
                                                        }}
                                                        message="Contact Phone Number must be between 7 and 12 digits"
                                                    />
                                                </SimpleItem>
                                            )}

                                            {/* DATE OF REQUEST */}
                                            {(isPatentInfringement || isCopyrightCounterNotice || isImageInfringement || isTrademarkInfringement) && (
                                                <SimpleItem dataField="request_date" editorType="dxDateBox" editorOptions={dateBoxOptions}>
                                                    <Label text="Date of Request" />
                                                    <RequiredRule message="Date of Request is required" />
                                                </SimpleItem>
                                            )}

                                            {/* DATE OF INFRINGEMENT IDENTIFIED */}
                                            {(isPatentInfringement || isCopyrightCounterNotice || isImageInfringement || isTrademarkInfringement) && (
                                                <SimpleItem dataField="date_of_infringement" editorType="dxDateBox" editorOptions={dateBoxOptions}>
                                                    <Label text="Date of Infringement Identified" />
                                                    <RequiredRule message="Date of Infringement is required" />
                                                </SimpleItem>
                                            )}
                                        </GroupItem>
                                    )}

                                    {/* DESCRIBE THE INFRINGEMENT */}
                                    {isPatentInfringement && (
                                        <SimpleItem
                                            dataField="infringement_description"
                                            editorType="dxHtmlEditor"
                                            editorOptions={getEditorOptions('infringement_description')}
                                        >
                                            <Label text="Describe the Infringement" />

                                            <RequiredRule message="This field is required" />
                                            <StringLengthRule
                                                max={4000}
                                                message="Content must not exceed 4000 characters"
                                            />
                                        </SimpleItem>
                                    )}

                                    {/* LIST OR IDENTIFY THE TRADEMARK */}
                                    {isTrademarkInfringement && (
                                        <SimpleItem
                                            dataField="trademark_url"
                                            editorType="dxHtmlEditor"
                                            editorOptions={getEditorOptions('trademark_url')}
                                        >
                                            <Label text="Please list or identify the Trademark you believe has been infringed, including any designation which you believe infringes or misuses the Trademark, and the sites or listing(s) on which the Trademark is allegedly being misused. Please provide the URL or link if possible." />

                                            <RequiredRule message="This field is required" />
                                            <StringLengthRule
                                                max={4000}
                                                message="Content must not exceed 4000 characters"
                                            />
                                        </SimpleItem>
                                    )}

                                    {/* LOCATION ON INFRINGEMENT INDENTIFIED */}
                                    {(isTrademarkInfringement || isPatentInfringement) && (
                                        <SimpleItem dataField="location_infringement" editorOptions={{ validationMessageMode: 'always' }}>
                                            <Label text="Location on Infringement Indentified (e.g., billboard, specific store, etc)" />

                                            <RequiredRule message="This field is required" />
                                            <PatternRule
                                                message={textValidationPatternMessage}
                                                pattern={textValidationPattern}
                                            />
                                            <StringLengthRule
                                                max={200}
                                                message="Location on Infringement Indentified must not exceed 200 characters"
                                            />
                                        </SimpleItem>
                                    )}

                                    {/* LIST OR IDENTIFY THE COPYRIGHTED WORK CLAIMED */}
                                    {isImageInfringement && (
                                        <SimpleItem
                                            dataField="list_copyrighted_work"
                                            editorType="dxHtmlEditor"
                                            editorOptions={getEditorOptions('list_copyrighted_work')}
                                        >
                                            <Label text="Please list or identify the copyrighted work claimed to have been infringed, or a representative list of such works at that site." />

                                            <RequiredRule message="This field is required" />
                                            <StringLengthRule
                                                max={4000}
                                                message="Content must not exceed 4000 characters"
                                            />
                                        </SimpleItem>
                                    )}

                                    {/* LIST OR IDENTIFY THE MATERIALS */}
                                    {isImageInfringement && (
                                        <SimpleItem
                                            dataField="list_materials_claimed"
                                            editorType="dxHtmlEditor"
                                            editorOptions={getEditorOptions('list_materials_claimed')}
                                        >
                                            <Label text="Please list or identify the materials that are claimed to be infringed or to be the subject of infringing activity and that is to be removed, and information reasonably sufficient to permit the service provider to locate the material." />

                                            <RequiredRule message="This field is required" />
                                            <StringLengthRule
                                                max={4000}
                                                message="Content must not exceed 4000 characters"
                                            />
                                        </SimpleItem>
                                    )}

                                    {isCopyrightCounterNotice && (
                                        <GroupItem colCount={2}>
                                            {/* NAME */}
                                            <SimpleItem dataField="name" editorOptions={{ validationMessageMode: 'always' }}>
                                                <PatternRule
                                                    message={textValidationPatternMessage}
                                                    pattern={textValidationPattern}
                                                />
                                                <StringLengthRule
                                                    max={200}
                                                    message="Name must not exceed 200 characters"
                                                />
                                            </SimpleItem>

                                            {/* EMAIL */}
                                            <SimpleItem dataField="email" editorOptions={{ validationMessageMode: 'always' }}>
                                                <Label text="Email Address" />
                                                <RequiredRule message="Email Address is required" />
                                                <EmailRule />
                                            </SimpleItem>

                                            {/* MAILING ADDRESS */}
                                            <SimpleItem dataField="mailing_address" editorOptions={{ validationMessageMode: 'always' }}>
                                                <Label text='Mailing Address' />

                                                <PatternRule
                                                    message={textValidationPatternMessage}
                                                    pattern={textValidationPattern}
                                                />
                                                <StringLengthRule
                                                    max={200}
                                                    message="Mailing Address must not exceed 200 characters"
                                                />
                                            </SimpleItem>

                                            {/* PHONE NUMBER */}
                                            <SimpleItem
                                                dataField="phone"
                                                editorType="dxNumberBox"
                                                editorOptions={{
                                                    validationMessageMode: 'always',
                                                    onInitialized: disableUpDownArrow,
                                                    format: '#', // This ensures only integers are accepted
                                                }}
                                            >
                                                <Label text="Phone Number" />

                                                <CustomRule
                                                    validationCallback={(e) => {
                                                        const value = e.value.toString();
                                                        return (value.length === 0) || (value.length >= 7 && value.length <= 12);
                                                    }}
                                                    message="Phone Number must be between 7 and 12 digits"
                                                />
                                            </SimpleItem>
                                        </GroupItem>
                                    )}

                                    {/* IDENTIFY THE SPECIFIC CONTENT */}
                                    {isCopyrightCounterNotice && (
                                        <SimpleItem
                                            dataField="other_location_information"
                                            editorType="dxHtmlEditor"
                                            editorOptions={getEditorOptions('other_location_information')}
                                        >
                                            <Label text="Clearly identify the specific content that was removed or disabled and the location that content appeared on our Site before its removal or other. Please provide a URL address if possible or other location information." />

                                            <RequiredRule message="This field is required" />
                                            <StringLengthRule
                                                max={4000}
                                                message="Content must not exceed 4000 characters"
                                            />
                                        </SimpleItem>
                                    )}

                                    {(isPatentInfringement || isCopyrightCounterNotice || isImageInfringement || isTrademarkInfringement) && (
                                        <GroupItem caption="Evidence Of Violation">
                                            {/* EVIDENCE PROVIDED */}
                                            <GroupItem>
                                                <Label text="Evidence Provided (check all that apply)" />
                                                <GroupItem colCount={4}>
                                                    <SimpleItem
                                                        dataField="advertisement"
                                                        editorType="dxCheckBox"
                                                        editorOptions={{ text: 'Advertisement', value: isOpt1 }}
                                                        label={{ visible: false }}
                                                    >
                                                        <CustomRule validationCallback={validationCallback} message="At least one option must be selected"></CustomRule>
                                                    </SimpleItem>
                                                    <SimpleItem
                                                        dataField="other"
                                                        editorType="dxCheckBox"
                                                        editorOptions={{ text: 'Other', value: isOpt2 }}
                                                        label={{ visible: false }}
                                                    >
                                                        <CustomRule validationCallback={validationCallback} message="At least one option must be selected"></CustomRule>
                                                    </SimpleItem>
                                                    <SimpleItem
                                                        dataField="photos"
                                                        editorType="dxCheckBox"
                                                        editorOptions={{ text: 'Photos', value: isOpt3 }}
                                                        label={{ visible: false }}
                                                    >
                                                        <CustomRule validationCallback={validationCallback} message="At least one option must be selected"></CustomRule>
                                                    </SimpleItem>
                                                    <SimpleItem
                                                        dataField="product_manual"
                                                        editorType="dxCheckBox"
                                                        editorOptions={{ text: 'Product Manual/Brochures', value: isOpt4 }}
                                                        label={{ visible: false }}
                                                    >
                                                        <CustomRule validationCallback={validationCallback} message="At least one option must be selected"></CustomRule>
                                                    </SimpleItem>
                                                    <SimpleItem
                                                        dataField="software"
                                                        editorType="dxCheckBox"
                                                        editorOptions={{ text: 'Software', value: isOpt5 }}
                                                        label={{ visible: false }}
                                                    >
                                                        <CustomRule validationCallback={validationCallback} message="At least one option must be selected"></CustomRule>
                                                    </SimpleItem>
                                                    <SimpleItem
                                                        dataField="video"
                                                        editorType="dxCheckBox"
                                                        editorOptions={{ text: 'Video', value: isOpt6 }}
                                                        label={{ visible: false }}
                                                    >
                                                        <CustomRule validationCallback={validationCallback} message="At least one option must be selected"></CustomRule>
                                                    </SimpleItem>
                                                    <SimpleItem
                                                        dataField="url_violation"
                                                        editorType="dxCheckBox"
                                                        editorOptions={{ text: 'Website Url Violation', value: isOpt7 }}
                                                        label={{ visible: false }}
                                                    >
                                                        <CustomRule validationCallback={validationCallback} message="At least one option must be selected"></CustomRule>
                                                    </SimpleItem>
                                                    <SimpleItem
                                                        dataField="website_violation"
                                                        editorType="dxCheckBox"
                                                        editorOptions={{ text: 'Website Violation', value: isOpt8 }}
                                                        label={{ visible: false }}
                                                    >
                                                        <CustomRule validationCallback={validationCallback} message="At least one option must be selected"></CustomRule>
                                                    </SimpleItem>
                                                </GroupItem>
                                                <RequiredRule message="Evidence Provided is required" />
                                            </GroupItem>
                                        </GroupItem>
                                    )}

                                    {isImageInfringement && (
                                        <GroupItem colCount={2}>
                                            {/* ADDRESS */}
                                            <SimpleItem dataField="address" editorOptions={{ validationMessageMode: 'always' }}>
                                                <RequiredRule message="Address is required" />
                                                <PatternRule
                                                    message={textValidationPatternMessage}
                                                    pattern={textValidationPattern}
                                                />
                                                <StringLengthRule
                                                    max={200}
                                                    message="Address must not exceed 200 characters"
                                                />
                                            </SimpleItem>

                                            {/* EMAIL ADDRESS */}
                                            <SimpleItem dataField="email_address" editorOptions={{ validationMessageMode: 'always' }}>
                                                <Label text='Email Address' />

                                                <RequiredRule message="Email Address is required" />
                                                <EmailRule />
                                            </SimpleItem>
                                        </GroupItem>
                                    )}

                                    {(isTrademarkInfringement || isImageInfringement || isPatentInfringement) && (
                                        <GroupItem
                                            // colCount={2}
                                            caption="Complainant Information">
                                            {/* COMPANY NAME */}
                                            <SimpleItem dataField="company" editorOptions={{ validationMessageMode: 'always' }}>
                                                <Label text="Company Name" />

                                                <PatternRule
                                                    message={textValidationPatternMessage}
                                                    pattern={textValidationPattern}
                                                />
                                                <StringLengthRule
                                                    max={200}
                                                    message="Company Name must not exceed 200 characters"
                                                />
                                            </SimpleItem>

                                            {/* WEBSITE */}
                                            <SimpleItem
                                                dataField="website"
                                                editorType="dxHtmlEditor"
                                                editorOptions={getEditorOptions('website')}
                                            >
                                                <Label text="Website" />

                                                <StringLengthRule
                                                    max={1000}
                                                    message="Content must not exceed 1000 characters"
                                                />
                                            </SimpleItem>
                                        </GroupItem>
                                    )}

                                    <GroupItem>
                                        {/* PRIORITY */}
                                        <SimpleItem
                                            dataField="priority"
                                            editorType="dxSelectBox"
                                            editorOptions={{
                                                dataSource: priorityEditorOptions,
                                                valueExpr: "id",
                                                displayExpr: "name",
                                            }}
                                        >
                                            <Label text="Priority" />
                                        </SimpleItem>

                                        {/* SUMMARY */}
                                        <SimpleItem
                                            dataField="summary"
                                            editorType="dxHtmlEditor"
                                            editorOptions={getEditorOptions('summary')}
                                        >
                                            <Label text="Summary" />

                                            <StringLengthRule
                                                max={4000}
                                                message="Content must not exceed 4000 characters"
                                            />
                                        </SimpleItem>

                                        {/* SIGNATURE */}
                                        <SimpleItem
                                            dataField="signature"
                                            editorOptions={{ validationMessageMode: 'always' }}
                                            helpText='Signature must begin with "/s/ "'
                                        >
                                            <Label text="/s/ Signature" />

                                            <RequiredRule message="Signature is required" />
                                            <PatternRule
                                                message={`Signature must begin with '/s/ '. ${textValidationPatternMessage}`}
                                                pattern={signaturePattern}
                                            />
                                            <StringLengthRule
                                                max={200}
                                                message="Signature must not exceed 200 characters"
                                            />
                                        </SimpleItem>
                                    </GroupItem>

                                    {isImageInfringement && (
                                        <SimpleItem>
                                            By submitting this request, I have a good faith belief that the material that is claimed as copyright infringement is not authorized by the copyright owner, its agent, or the law.
                                        </SimpleItem>
                                    )}

                                    {(isTrademarkInfringement || isPatentInfringement) && (
                                        <SimpleItem>
                                            By submitting this request, the information in this notification is accurate, and under penalty of perjury, the complaining party is authorized to act on behalf of the owner of an exclusive right that is allegedly infringed.
                                        </SimpleItem>
                                    )}
                                </GroupItem>

                                <GroupItem caption="Attachment">
                                    {/* ATTACHMENT */}
                                    <SimpleItem>
                                        <div className="main-block">
                                            <FileUploader
                                                selectButtonText="Select files"
                                                multiple={true}
                                                uploadMode="useForms"
                                                value={selectedFiles}
                                                allowedFileExtensions={fileExtensions}
                                                maxFileSize={totMaxFileSize}
                                                onValueChanged={handleFileChange}
                                                accept='.jpg,.jpeg,.png,.pdf'
                                            />
                                            <span className="note">
                                                Attachments Instructions:
                                                <ul>
                                                    <li>Please upload any related files to this request.</li>
                                                </ul>
                                                <br />
                                                Note:
                                                <ul>
                                                    <li>Max {maxFileUploadAllowed} files can be uploaded.</li>
                                                    <li>Only .PDF, .JPG/.JPEG, .PNG file allowed.</li>
                                                    <li>Total file size should not exceed 25MB.</li>
                                                </ul>
                                            </span>
                                        </div>
                                    </SimpleItem>
                                </GroupItem>
                            </GroupItem>

                            {/* CAPTCHA */}
                            <GroupItem colCount={5}>
                                <SimpleItem>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <div dangerouslySetInnerHTML={{ __html: captchaImage }} />
                                        <Button
                                            tet="Refresh CAPTCHA"
                                            type="icon"
                                            icon="refresh"
                                            onClick={fetchCaptcha}
                                            elementAttr={{ title: "Refresh CAPTCHA" }}
                                            style={{ margin: 'auto' }}
                                        />
                                    </div>
                                </SimpleItem>

                                <SimpleItem
                                    editorType='dxTextBox'
                                    editorOptions={{
                                        value: userCaptcha,
                                        placeholder: "Enter CAPTCHA",
                                        valueChangeEvent: 'keyup',
                                        onValueChanged: handleCaptchaEntry,
                                        validationMessageMode: "always"
                                    }}
                                >
                                    <RequiredRule message="CAPTCHA is required" />
                                </SimpleItem>
                            </GroupItem>

                            {/* NEW APPROACH BOL */}
                            <GroupItem
                                // colCount={2} 
                                cssClass="buttons-group"
                            >
                                <ButtonItem
                                    buttonOptions={submitButtonOptions}
                                    horizontalAlignment="center"
                                    verticalAlignment="bottom" 
                                    onClick={handleSubmit}
                                />
                            </GroupItem>
                            {/* NEW APPROACH EOL */}
                        </Form>
                    </form>

                    <LoadPanel
                        visible={isSubmitting}
                        shadingColor="rgba(0,0,0,0.4)"
                        message="Submitting..."
                    />

                    {/* FOR POP-UP */}
                    <Popup
                        visible={popupVisible}
                        onHiding={hidePopup}
                        dragEnabled={true}
                        // closeOnOutsideClick={true}
                        showCloseButton={false}
                        title="&nbsp;&nbsp;Success"
                        width={440}
                        height={200}
                        animation={{
                            show: {
                                type: 'fade', // Animation type for showing the popup
                                duration: 400, // Duration of the show animation
                                from: { opacity: 0 }, // Initial state
                                to: { opacity: 1 } // Final state
                            },
                            hide: {
                                type: 'fade', // Animation type for hiding the popup
                                duration: 400, // Duration of the hide animation
                                from: { opacity: 1 }, // Initial state
                                to: { opacity: 0 } // Final state
                            }
                        }}
                    >
                        <div>
                            <p>{successMessage}</p>
                            <p>Please copy the request number for tracking your request.</p>
                            <Button
                                text="Close"
                                type="normal" // accepts one of the following values: 'normal', 'default', 'success', 'danger'
                                onClick={hidePopup}
                            />
                        </div>
                    </Popup>
                </div>
            </div>
        </React.Fragment >
    );
}

export default InfringementAlert;